import GET_BUYING_SESSION_PRODUCT_COUNT from './buyingSessionProductsCount.graphql'

export default GET_BUYING_SESSION_PRODUCT_COUNT
